exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-75b5fd8b]{max-width:var(--measure);margin:0;line-height:var(--body-line-height)}", ""]);

// exports
